import React from 'react';

import classNames from 'classnames';

const TRENDS = {
    worse: { arrow: '▲', className: 'tw-text-red', label: () => $t('Worse than the last issued pack') },
    better: { arrow: '▼', className: 'tw-text-green', label: () => $t('Better than the last issued pack') },
    held: { arrow: '▬', className: 'tw-text-charcoal', label: () => $t('Unchanged since the last issued pack') },
};

/**
 * A status's trend against the movement basis pack. Draws nothing when there
 * is no trend (no issued pack, or no earlier status to compare with).
 */
const TrendArrow = ({ trend, className }) => {
    const config = TRENDS[trend];

    if (!config) {
        return null;
    }

    const label = config.label();

    return (
        <span role="img" aria-label={label} title={label} className={classNames(config.className, className)}>
            {config.arrow}
        </span>
    );
};

export default TrendArrow;
